import type { ReactNode } from 'react';
import type { HotelSearchValue, HotelTravelerOption } from '../models.js';
import { TravelerAvatarStack } from '../../shared/person/traveler_picker.js';
import { toPerson } from './hotel_rooms_pickers.js';

/**
 * Os retratos do campo QUEM: a pilha dos hóspedes nomeados, a mesma do gatilho
 * do aéreo (`TravelerAvatarStack`). O desenho põe PESSOAS ali, não o conceito
 * de "pessoas"; sem hóspede nomeado, a pessoa que a busca conhece é quem rege
 * a política ou o solicitante.
 *
 * O retrato é o dos seletores de pessoa (`PersonAvatar`): a foto do perfil
 * (#2640) quando o host a costurou na opção, as iniciais senão. Sem nome
 * nenhum não há retrato e o campo volta ao ícone de pessoas, que é o honesto
 * sobre uma contagem sem identidade.
 */
export function guestGlyph(
  value: HotelSearchValue,
  travelers: readonly HotelTravelerOption[],
  requesterId: string | undefined,
): ReactNode {
  const fallback = value.policyTravelerId ?? requesterId;
  const ids = value.travelerIds.length > 0 ? value.travelerIds : fallback ? [fallback] : [];
  const people = ids.flatMap((id) => {
    const guest = travelers.find((traveler) => traveler.id === id);
    return guest?.label.trim() ? [toPerson(guest)] : [];
  });
  if (people.length === 0) return undefined;
  return <TravelerAvatarStack people={people} max={2} />;
}
